// Format phone
export const phone = phone => {
  return phone?.replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3')
}

// Format cep
export const cep = cep => {
  return cep?.replace(/^([\d]{2})\.*([\d]{3})-*([\d]{3})/, '$1$2-$3')
}
